import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, fromEvent, takeUntil } from 'rxjs';
import { SuccessAccountCreatedComponent } from 'src/app/shared/modal/success-account-created/success-account-created.component';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-restaurant-dash',
  templateUrl: './restaurant-dash.component.html',
  styleUrls: ['./restaurant-dash.component.scss']
})
export class RestaurantDashComponent implements OnInit {

   // ********************************************************************************************
  // VARIABLE START

  // VARIABLE END
  // ********************************************************************************************



// ********************************************************************************************
  // DEFAULT START
  constructor(
    private csObj: CommonService,

  ) {


  }

  ngOnInit(): void {


  }
  // DEFAULT END
  // ********************************************************************************************




}
